import React from 'react';
import styled from 'styled-components';
import { IStyled } from '../../styles/types';
import Loader from './Loader';
import { theme } from '../../styles/theme';
import { borderedContent } from '../../styles/shareableStyles';

interface IProps extends IStyled {
  noBorders?: boolean;
}

const Container = styled.div<{ $noBorders?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 440px;
  padding: 40px 30px;
  background-color: ${theme.colors.level1};
  ${({ $noBorders }) => !$noBorders && borderedContent}
`;

const ContentLoader = ({ noBorders, className }: IProps) => (
  <Container className={className} $noBorders={noBorders}>
    <Loader />
  </Container>
);

export default ContentLoader;
